import { render, staticRenderFns } from "./ReportEditDialog.vue?vue&type=template&id=b2db61b4"
import script from "./ReportEditDialog.vue?vue&type=script&lang=js"
export * from "./ReportEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports